/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Close_TicketInputs */

const en_settings_tickets_close_ticket = /** @type {(inputs: Settings_Tickets_Close_TicketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Ticket`)
};

const zh_settings_tickets_close_ticket = /** @type {(inputs: Settings_Tickets_Close_TicketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭工单`)
};

/**
* | output |
* | --- |
* | "Close Ticket" |
*
* @param {Settings_Tickets_Close_TicketInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_close_ticket = /** @type {((inputs?: Settings_Tickets_Close_TicketInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Close_TicketInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_close_ticket(inputs)
	return zh_settings_tickets_close_ticket(inputs)
});
export { settings_tickets_close_ticket as "settings.tickets.close_ticket" }